/**
 * Benefits Block Tabs Functionality
 * Handles tab switching for the benefits block with CSS custom properties
 */

const BenefitsTabs = {
    /**
     * Initialize tabs functionality
     */
    init() {
        const tabButtons = document.querySelectorAll('.benefits .tab-button');

        if (tabButtons.length === 0) {
            return;
        }

        tabButtons.forEach(button => {
            button.addEventListener('click', (e) => this.handleTabClick(e));
        });

        const activePanel = document.querySelector('.benefits .tab-panel.active');
        if (activePanel) {
            this.initShowMore(activePanel);
        }

        console.log('✅ Benefits tabs initialized');
    },

    /**
     * Handle tab button click
     * @param {Event} e - Click event
     */
    handleTabClick(e) {
        const button = e.currentTarget;
        const tabItem = button.closest('.tab-item');
        const tabId = button.getAttribute('aria-controls');
        const tabPanel = document.getElementById(tabId);

        if (!tabPanel || !tabItem) {
            return;
        }

        // Get CSS custom properties from the tab item
        const styles = window.getComputedStyle(tabItem);
        const activeBg = styles.getPropertyValue('--active-bg').trim();
        const activeColor = styles.getPropertyValue('--active-color').trim();

        // Deactivate all tabs
        this.deactivateAllTabs();

        // Activate current tab
        this.activateTab(tabItem, button, activeBg, activeColor);

        // Activate panel
        this.activatePanel(tabPanel, activeBg);

        this.initShowMore(tabPanel);

        if (window.innerWidth < 768) {
            const container = button.closest('.tabs-navigation');
            const containerRect = container.getBoundingClientRect();
            const buttonRect = button.getBoundingClientRect();

            const offset = (buttonRect.left + buttonRect.width / 2) - (containerRect.left + containerRect.width / 2);

            container.scrollBy({
                left: offset,
                behavior: 'smooth'
            });
        }
    },

    /**
     * Deactivate all tabs and panels
     */
    deactivateAllTabs() {
        // Deactivate all tab items
        document.querySelectorAll('.benefits .tab-item').forEach(item => {
            item.classList.remove('active');
            const btn = item.querySelector('.tab-button');
            if (btn) {
                btn.setAttribute('aria-selected', 'false');
            }
        });

        // Deactivate all panels
        document.querySelectorAll('.benefits .tab-panel').forEach(panel => {
            panel.classList.remove('active');
            panel.setAttribute('hidden', '');
        });
    },

    /**
     * Activate a specific tab
     * @param {HTMLElement} tabItem - Tab item element
     * @param {HTMLElement} button - Tab button element
     * @param {string} activeBg - Background color for active state
     * @param {string} activeColor - Text color for active state
     */
    activateTab(tabItem, button, activeBg, activeColor) {
        tabItem.classList.add('active');
        button.setAttribute('aria-selected', 'true');
    },

    /**
     * Activate a specific panel
     * @param {HTMLElement} panel - Panel element
     * @param {string} activeBg - Background color for card icons
     */
    activatePanel(panel, activeBg) {
        panel.classList.add('active');
        panel.removeAttribute('hidden');

        // Set opacity: 1 for cards-container
        const cardsContainers = panel.querySelectorAll('.cards-container');
        cardsContainers.forEach(container => {
            container.style.opacity = '1';
        });

        // Update card icon colors if active background is set
        if (activeBg) {
            const cardIcons = panel.querySelectorAll('.card-icon');
            cardIcons.forEach(icon => {
                icon.style.backgroundColor = activeBg;
            });
        }
    },

    initShowMore(panel) {
        const cards = panel.querySelectorAll('.card-item');
        const button = panel.querySelector('.show-more-btn');

        if (!cards.length || !button) return;

        cards.forEach((card, index) => {
            if (index > 3) card.classList.add('hidden');
            else card.classList.remove('hidden');
        });

        button.style.display = cards.length > 4 ? 'inline-block' : 'none';

        const newButton = button.cloneNode(true);
        button.parentNode.replaceChild(newButton, button);

        newButton.addEventListener('click', () => {
            cards.forEach(card => card.classList.remove('hidden'));
            newButton.style.display = 'none';
        });
    }
};

export default BenefitsTabs;